import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { MaterialCountActionTypes } from "./MaterialCount.type";

export function* fetchAllMaterialCounts(action: any): any {
  try {
    let query = "";
    if (action.payload) {
      const keys = Object.keys(action.payload);
      query = keys.map((key) => `${key}=${action.payload[key]}`).join("&");
    }
    const response = yield axios.get(
      `${API_BASE_URI}/material-count?${query}`
    );
    yield put({
      type: MaterialCountActionTypes.FETCH_ALL_MATERIAL_COUNT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MaterialCountActionTypes.FETCH_ALL_MATERIAL_COUNT_FAILURE,
      payload: error,
    });
  }
}

export function* bulkUpsertMaterialCounts(action: any): any {
  try {
    const response = yield axios.post(
      `${API_BASE_URI}/material-count/bulk-upsert`,
      { items: action.payload }
    );
    yield put({
      type: MaterialCountActionTypes.BULK_UPSERT_MATERIAL_COUNT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MaterialCountActionTypes.BULK_UPSERT_MATERIAL_COUNT_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllMaterialCounts() {
  yield takeLatest(
    MaterialCountActionTypes.FETCH_ALL_MATERIAL_COUNT,
    fetchAllMaterialCounts
  );
}

export function* watcherBulkUpsertMaterialCounts() {
  yield takeLatest(
    MaterialCountActionTypes.BULK_UPSERT_MATERIAL_COUNT,
    bulkUpsertMaterialCounts
  );
}
